var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValidateUnfilled = function SvgValidateUnfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 8c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8-8-3.6-8-8m2 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6m5 .8 3.3-3.5c.4-.4 1-.4 1.4-.1.4.4.4 1.05 0 1.45L8.05 10.5c-.25.3-.65.45-1.05.45s-.75-.15-1.05-.4L4.3 8.7c-.4-.4-.4-1 0-1.4s1-.4 1.4 0z",
    clipRule: "evenodd"
  })));
};
export default SvgValidateUnfilled;